/** @format */

export const handleCleanDelivery = (cart) => {
	let products = cart
	products.map((item) => {
		return (item.type_retirement = null)
	})
	return products
}
